export function getCookieBarHTML (params) {
    params = {
        getDeclineButtonHTML,
        getAcceptNecessaryButtonHTML,
        getCookieBarSettingsButtonHTML,
        getAcceptButtonHTML,
        getCookieBarDetailLinkHTML,
        ...params,
    };

    return (
        '<div class="cookie-bar js-cookie-bar">' +
        '  <div class="cookie-bar__left">' +
        '      <div class="cookie-bar__text">' +
        '          ' + _config.cookieBar.text +
        '      </div>' +
        '      <div class="cookie-bar__detail">' +
        '       ' + params.getCookieBarDetailLinkHTML() +
        '      </div>' +
        '  </div>' +
        '  <div class="cookie-bar__buttons">' +
        '      ' + params.getDeclineButtonHTML() +
        '      ' + params.getAcceptNecessaryButtonHTML() +
        '      ' + params.getCookieBarSettingsButtonHTML() +
        '      ' + params.getAcceptButtonHTML() +
        '  </div>' +
        '</div>'
    )
}

export function getDeclineButtonHTML() {
    return _config.cookieBar.decline
        ? '<button type="button" class="cookie-bar__btn cookie-bar__decline btn btn-danger js-cookie-bar__decline">' +
        '    ' + _config.cookieBar.decline +
        '</button>'
        : '';
}


export function getAcceptNecessaryButtonHTML() {
    return _config.cookieBar.acceptNecessary
        ? '<button type="button" class="cookie-bar__btn cookie-bar__accept-necessary btn btn-secondary js-cookie-bar__accept-necessary">' +
        '    ' + _config.cookieBar.acceptNecessary +
        '</button>'
        : '';
}

export function getCookieBarSettingsButtonHTML() {
    return _config.cookieBar.settings && _config.cookieServices && Object.keys(_config.cookieServices).length
        ? `<button type="button" class="cookie-bar__btn cookie-bar__settings-btn btn btn-${_config.cookieBar.accept ? 'secondary' : 'primary'} js-cookie-bar__detail">` +
        _config.cookieBar.settings +
        '</button>'
        : '';
}

export function getAcceptButtonHTML() {
    return _config.cookieBar.accept
        ? '<button type="button" class="cookie-bar__btn cookie-bar__accept btn btn-primary js-cookie-bar__accept">' +
        '    ' + _config.cookieBar.accept +
        '</button>'
        : '';
}

export function getCookieBarDetailLinkHTML() {
    return _config.cookieBar.detail
        ? '<a target="_blank" href="' + _config.cookieBar.detailUrl + '" class="cookie-bar__detail-link">' +
        _config.cookieBar.detail +
        '</a>'
        : '';
}

export function getSelectionDescriptionHTML({description}) {
    return (_config.cookieModal.detail && description)
        ? `<p class="cookie-selection__item-description">${description}</p>`
        : '';
}

export function getSelectionDetailLinkHTML({url}) {
    return (_config.cookieModal.detail && url)
        ? `<a class="cookie-selection__item-link" target="_blank" href="${url}">${_config.cookieModal.detail}</a>`
        : '';
}

export function getSelectionHTML({
                                     services,
                                     ...params
                                 }) {
    params = {
        getToggleHTML,
        getSelectionDescriptionHTML,
        getSelectionDetailLinkHTML,
        ...params
    };

    function findServiceIdsByGroupId(groupId) {
        return Object.keys(services).filter(function (serviceId) {
            return services[serviceId].group === groupId
        })
    }

    let markup = '';
    let options = [];

    if (Object.keys(services).length > 1) {
        markup += `<div class="cookie-selection__item cookie-selection__item--all">${params.getToggleHTML({
            label: _config.cookieModal.toggleAll,
            name: 'all',
            isChecked: areAllServicesAllowed(services)
        })}</div>`;
    }

    if (_config.cookieServiceGroups && Object.keys(_config.cookieServiceGroups).length) {
        let groups = Object.entries(_config.cookieServiceGroups).map(function (entry) {
            let groupId = entry[0];
            let group = entry[1];
            let serviceIds = findServiceIdsByGroupId(groupId);

            return Object.assign({}, group, {
                id: groupId,
                serviceIds: serviceIds
            });
        }).filter(function (group) {
            return !!group.serviceIds.length;
        }).map(function (group) {
            let isAllowed = group.serviceIds.reduce(function (result, serviceId) {
                if (result) {
                    return result;
                }

                return services[serviceId].isAllowed;
            }, false);

            options = group.serviceIds.map(function (serviceId ) {
                return ('<div class="cookie-selection__item">' +
                    params.getToggleHTML({
                        label: services[serviceId].text,
                        name: serviceId,
                        description: services[serviceId].description,
                        isChecked: services[serviceId].isAllowed,
                        isReadOnly: services[serviceId].isReadOnly,
                        group: services[serviceId].group,
                        className: 'cookie-toggle--small'
                    }) +
                    params.getSelectionDetailLinkHTML(services[serviceId]) +
                    params.getSelectionDescriptionHTML(services[serviceId]) +
                    '</div>'
                );
            });

            return (`
                <div class="cookie-group">
                    <div class="cookie-group__header">
                        <div class="cookie-group__header-title">
                            ${params.getToggleHTML({
                    label: group.name,
                    name: 'group-' + group.id,
                    isChecked: isAllowed,
                    isReadOnly: group.isReadOnly,
                    group: group.id
                })}
                        </div>
                        <button 
                            class="cookie-group__toggle collapsed"
                             type="button" 
                             data-bs-toggle="collapse" 
                             data-bs-target="#cookie-selection-group-${group.id}" 
                             data-toggle="collapse" 
                             data-target="#cookie-selection-group-${group.id}" 
                             aria-expanded="false"
                              aria-controls="cookie-selection-group-${group.id}">
                            <span class="cookie-group__toggle-icon" aria-hidden="true"></span>
                        </button>
                    </div>
                    <div class="collapse" id="cookie-selection-group-${group.id}">
                        <div class="cookie-group__description">
                            ${group.description}
                        </div>
                        <div class="cookie-group__body">
                            <div class="cookie-selection">
                                ${options.join('')}
                            </div>
                        </div>
                    </div>
                </div>`
            );
        });

        return `
            <div class="cookie-selection">
                ${markup + groups.join('')}
            </div>
        `;
    } else {
        options = options.concat(Object.keys(services).map(function (serviceName) {
            return ('<div class="cookie-selection__item">' +
                params.getToggleHTML({
                    label: services[serviceName].text,
                    name: serviceName,
                    description: services[serviceName].description,
                    isChecked: services[serviceName].isAllowed,
                    isReadOnly: services[serviceName].isReadOnly
                }) +
                params.getSelectionDetailLinkHTML(services[serviceName]) +
                params.getSelectionDescriptionHTML(services[serviceName]) +
                '</div>'
            );
        }));

        return `
            <div class="cookie-selection">
                ${markup + options.join('')}
            </div>
        `;
    }
}

export function getToggleHTML({label, name, isChecked, isReadOnly, group, className = ''}) {
    return (`
        <label class="cookie-toggle ${className}">
            <span class="cookie-toggle__switch ${isReadOnly ? 'is-disabled' : ''}">
                <input class="cookie-toggle__input sr-only visually-hidden" name="${name}" type="checkbox" ${isChecked ? 'checked' : ''} ${isReadOnly ? 'disabled' : ''} ${group ? 'data-group="' + group + '"' : ''}>
                <span class="cookie-toggle__switch-toggle"></span>
            </span>
            <span class="cookie-toggle__label">${label}</span>
        </label>
    `);
}

export function areAllServicesAllowed(services) {
    return Object.keys(services).reduce(function (allAllowed, currentServiceName) {
        return !services[currentServiceName].isAllowed ? false : allAllowed;
    }, true);
}